var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4042 6.59583C26.7667 -1.04167 14.2334 -1.04167 6.59588 6.59583C-1.04162 14.2333 -1.04162 26.7667 6.59588 34.4042C14.2334 42.0417 26.5709 42.0417 34.2084 34.4042C41.8459 26.7667 42.0417 14.2333 34.4042 6.59583ZM25.9834 28.725L20.5 23.2417L15.0167 28.725L12.275 25.9833L17.7584 20.5L12.275 15.0167L15.0167 12.275L20.5 17.7583L25.9834 12.275L28.725 15.0167L23.2417 20.5L28.725 25.9833L25.9834 28.725Z",
    fill: "#017BEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCloseButton);
export default __webpack_public_path__ + "static/media/blue-close-button.adf9851237138554f3c571168bf9d4eb.svg";
export { ForwardRef as ReactComponent };